// @flow
import React, { Component } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import safeUrl from '../util/safeUrl';

import MenuButton from './MenuButton.js';
import Progress from './Progress.js';
import navigationStructure from '../NavigationStructure.js';

import type { AppStateType} from '../Types';
import helpers from '../util/helpers';


import "../css/Header.css";

const getPosition = function(path: string): number {
  const keys = Object.keys(navigationStructure);
  return keys.indexOf(path) - 4;
}
const showProgress = function(path: string): boolean {
  return getPosition(path) >= 1;
}

type Props = {
  appState: AppStateType,
  location: Object
}

class Header extends Component<Props> {

  languageClicked(val) {

    let that = this;
    let page = this.props.location.pathname;
    let loggedOutPages = ["/", "/login"]
    let linkTo = "/about"
    if (!loggedOutPages.includes(page)) {
      linkTo = "/"
    }
    helpers.eventLog(`changeLanguageTo - ${val}`)
    setTimeout(function() {


      that.props.appState.changeLanguage(val);
      // we need the whole app to do a hard reload in the new language // not... that.props.history.push(`/`);
      // if (window.localStorage.getItem('uid') && window.localStorage.getItem('avatar'))
      // {
      //    window.location = '/#/about';  // XXX: ideally we go back to where we came from
      // }
      // else
      // {
      //   window.location = '/';
      // }
      window.location = linkTo
      window.location.reload(); // forces a reload even if there is a # in the URL
    }, 100);
  }



  render() {

    const { appState } = this.props;
    const path = safeUrl(`/images/${appState.avatar}.png`);
    const avatar = appState.avatar ? (<span className='printhide'><a href='/#/avatar'><img border='0' src={path} className='header-avatar' alt='Your Avatar' /></a></span>) : null;

    // const languageHTML    = appState.language ? (<span className='language printhide'><a href='/#/langset'>es/en</a></span>) : null;
    // console.log(appState.language);
    // console.log(languageHTML);
    let languageHTML;
    if (!appState.language) {
      languageHTML = null
    } else {
      if (appState.language == 'en') {
        languageHTML = (<span className='language printhide' onClick={() => this.languageClicked('es')}>Español</span>)
      } else if (appState.language == 'es') {
        languageHTML = (<span className='language printhide' onClick={() => this.languageClicked('en')}>English</span>)
      }
    }

    const progress = showProgress(this.props.location.pathname) ? (<Progress at={getPosition(this.props.location.pathname)} total={Object.keys(navigationStructure).length - 5} />) : null;
    //const progress = <Progress at={1} total={4} />;

    const menu = navigationStructure[this.props.location.pathname].menu === true ? <MenuButton appState={appState} /> : null;

    let page = this.props.location.pathname;
    let loggedOutPages = ["/", "/login"]
    let titleLink = (
      <div className="appTitle">
        <FormattedHTMLMessage id='app.title' defaultMessage='My <strong>IKIDS</strong>' />
      </div>
    )
    // if (loggedOutPages.includes(page)) {
    //   titleLink = <Link to='/' className="appTitle">
    //     <FormattedHTMLMessage id='app.title' defaultMessage='My <strong>IKIDS</strong>' />
    //   </Link>
    // } else {
    //   titleLink = <Link to='/about' className="appTitle">
    //     <FormattedHTMLMessage id='app.title' defaultMessage='My <strong>IKIDS</strong>' />
    //   </Link>
    // }

    return (
      <div>
        <header>
          {avatar}
          {titleLink}

          {//languageHTML
          }

          {menu}
        </header>

        {progress}
      </div>
    );
  }
};

export default withRouter(observer(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js